import React, { useMemo } from "react";
import "./ProjectsList.scss";
import { useSelector } from "react-redux";

import ProjectsTable from "./partials/ProjectsTable/ProjectsTable";
import { generateRows } from "./utils/generateRows";
import { generateColumns } from "./utils/generateColumns";
import { SelectedProjectsBar } from "./partials/ProjectsTable/components/SelectedProjectsBar";
import {
  computeSelectedRowsTotals,
  buildTotalRowRecord,
} from "src/app/methods/computeSelectedRowsTotals";

function computeProjectsTotalsMap(selectedProjects, projects, columns) {
  if (!selectedProjects.length || !projects.length || !columns.length)
    return {};

  const selectedIds = new Set(selectedProjects.map((p) => p.id));
  const selectedData = projects.filter((p) => selectedIds.has(p.projectId));

  const normalizedData = selectedData.map((project) => ({
    ...project,
    metadata: (project.metadata || []).map((meta) => ({
      ...meta,
      uuid: meta.wsGlobalProjectMetaFieldUuid || meta.uuid,
    })),
  }));

  const totals = computeSelectedRowsTotals(normalizedData, columns, {
    getCurrencyCode: (project) => project.data?.currencyCode,
  });
  return buildTotalRowRecord(totals);
}

export default function ProjectsList({
  projects,
  columns,
  setShowCreateProjectModal,
  listLoading,
  filtersRefreshing,
  filters,
}) {
  const hiddenColumns = useSelector(
    (state) => state.projectFiltersReducer.hiddenColumns,
  );

  const projectsCount = useSelector(
    (state) => state.projectReducer.projectsCount,
  );

  const projectsCountTotal = useSelector(
    (state) => state.projectReducer.projectsCountTotal,
  );

  const selectedProjects = useSelector(
    (state) => state.projectReducer.selectedProjects,
  );

  const nameHeader = `Displaying ${projectsCount} of ${projectsCountTotal}`;

  const totals = useMemo(
    () => computeProjectsTotalsMap(selectedProjects, projects, columns),
    [selectedProjects, projects, columns],
  );

  return (
    <div className="projects-list-data">
      <ProjectsTable
        data={generateRows(projects, columns)}
        columns={generateColumns(columns, hiddenColumns, nameHeader)}
        setShowCreateProjectModal={setShowCreateProjectModal}
        listLoading={listLoading}
        filtersRefreshing={filtersRefreshing}
        filters={filters}
        totals={totals}
      />

      {selectedProjects.length > 0 && <SelectedProjectsBar />}
    </div>
  );
}
